const map = {
  // 媒介佣金穿透
  shopCpsOrderSummary: () => import('@/views/cpsBill/ShopCpsOrderSummary'), // 店铺CPS订单汇总
  shopCpsOrderDetails: () => import('@/views/cpsBill/ShopCpsOrderDetails') // 店铺CPS订单明细
}

export default map
